import styled from "styled-components";

export const MarketplaceNavbarWrapper = styled.div`
  margin-top: 50px;
  margin-bottom: 30px;
  @media (max-width: 767.98px) {
    margin-bottom: 20px;
  }
`;

export const MarketplaceMain = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 767.98px) {
    flex-direction: column;
    align-items: flex-start;
  }
  & h2 {
    font-family: "Inter";
    font-style: normal;
    font-weight: 900;
    font-size: 36px;
    line-height: 126.2%;
    color: #0088cc;

    @media (max-width: 991.98px) {
      font-size: 32px;
    }
    @media (max-width: 767.98px) {
      height: 100%;
      margin-bottom: 15px;
    }
    @media (max-width: 477.98px) {
      font-size: 27px;
    }
  }
  & > div {
    display: flex;
    align-items: center;
    margin-left: 20px;
    @media (max-width: 767.98px) {
      margin-left: 0;
    }
  }
`;

export const MarketplaceNavbarButton = styled.button`
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 126.2%;
  background: transparent;
  border: none;
  padding: 6px 10px;
  outline: none;
  color: ${(props) => props.theme.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  border: 1px solid transparent;
  cursor: pointer;
  @media (max-width: 767.98px) {
    margin-left: 0;
  }
  &.active {
    color: #0088cc; /* Rectangle 3330 */
    border: 1px solid #0088cc;
    border-radius: 27px;
  }
`;
